/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/aspect-ratio'),
    ],
  }
  ```
*/
import { Link } from "react-router-dom";

const project = {
  title: "Create New Project",
  thumbnail: "https://i.ibb.co/HHQ3758/tracktube-plus.jpg",
};

export default function CreateProjectCard() {
  return (
    <div
      className="cursor-pointer w-80 rounded-xl bg-slate-100 shadow-md"
      style={{ marginTop: "20px", marginBottom: "30px" }}
    >
      <Link to={`/dashboard/create-project`}>
        <div className="w-max h-max overflow-hidden rounded-t-xl aspect-h-1 aspect-w-2 group-hover:opacity-75">
          <img
            src={project.thumbnail}
            alt="some-text"
            className="h-auto object-cover object-center"
          />
        </div>
        <p className="ml-2 text-lg font-semibold text-gray-900 my-2 max-w-full">
          {project.title}
        </p>
      </Link>
    </div>
  );
}
